// extracted by mini-css-extract-plugin
export default {"menuControls":"c-a_eT","menuControls_styleDefault":"c-a_eU","menuControls_styleRed":"c-a_eV"};